import React, { useState } from 'react';
import { ArrowRightIcon, InstagramIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { GlowFrame } from './GlowFrame';
import { FormModal } from './FormModal';
import type { FormFieldConfig } from '../types/contact';
const ENQUIRY_CARDS = [{
  type: 'Venues & Festivals',
  description: 'Bring the full production to your stage.'
}, {
  type: 'Special Events & Partners',
  description: 'Co-productions, sponsorships and collaborations.'
}, {
  type: 'Media',
  description: 'Press access, interviews and coverage.'
}];
const ENQUIRY_FIELDS: FormFieldConfig[] = [{
  id: 'name',
  label: 'Name',
  type: 'text',
  required: true
}, {
  id: 'organisation',
  label: 'Organisation',
  type: 'text',
  required: true
}, {
  id: 'email',
  label: 'Email',
  type: 'email',
  required: true
}, {
  id: 'message',
  label: 'Message',
  type: 'textarea',
  required: true
}];
export function ContactSection() {
  const [enquiryType, setEnquiryType] = useState<string | null>(null);
  return <section id="contact" aria-label="Contact" className="bg-ink px-5 py-24 sm:px-8 lg:px-12 lg:py-32" data-id="element-46" data-mp="7lmu0cgvwnba">
      <div className="mx-auto max-w-5xl" data-id="element-47" data-mp="2nla5pbmwjyr">
        <Reveal data-id="element-48" data-mp="2owf3sgtfxrg">
          <h2 className="mb-14 text-center font-heading text-4xl uppercase leading-tight tracking-tight text-led sm:text-5xl lg:text-6xl" data-id="element-49" data-mp="2pekpfpdboc1">
            The Doors of Perception in your city
          </h2>
        </Reveal>

        <div className="grid gap-6 sm:grid-cols-3" data-id="element-50" data-mp="qkr1vhwowb1d">
          {ENQUIRY_CARDS.map((card, index) => <Reveal key={card.type} delay={index * 0.1} data-id="element-51" data-mp="lm7c16ez6f3q" data-mpi={index}>
              <GlowFrame as="button" interactive onClick={() => setEnquiryType(card.type)} className="group flex h-full min-h-[16rem] w-full flex-col justify-between p-6 text-left" data-id="element-52" data-mp="llnwfwcss2sv">
                <p className="font-heading text-xl uppercase tracking-tight text-led" data-id="element-53" data-mp="19aqozz8yzg25">{card.type}</p>
                <div data-id="element-54" data-mp="14d6zg36tnguw">
                  <p className="mb-4 text-sm text-led/60" data-id="element-55" data-mp="14e06z6dluae3">{card.description}</p>
                  <ArrowRightIcon className="h-5 w-5 text-led/55 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-ice" aria-hidden="true" data-id="element-56" data-mp="202a2vsj73kg" />
                </div>
              </GlowFrame>
            </Reveal>)}
        </div>

        <Reveal delay={0.2} data-id="element-57" data-mp="frz0mvejx5eq">
          <div className="mt-14 flex flex-col items-center gap-4 text-center" data-id="element-58" data-mp="fs8tcqqzdqo4">
            <a href="mailto:dop2026live@gmail.com" className="border-b border-ice/50 pb-2 text-sm tracking-[0.12em] text-led transition-colors duration-300 hover:border-ice hover:text-ice focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice" data-id="element-59" data-mp="kp8zf1ntytf8">
              dop2026live@gmail.com
            </a>
            <a href="https://www.instagram.com/doorsofperceptionlive" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 text-sm tracking-[0.08em] text-led/60 transition-colors duration-300 hover:text-ice focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice" data-id="element-60" data-mp="2wfte63xbqdtn">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="2j717d9mmfwqa" />
              @doorsofperceptionlive
            </a>
          </div>
        </Reveal>
      </div>

      <FormModal isOpen={enquiryType !== null} onClose={() => setEnquiryType(null)} title={enquiryType ? `${enquiryType} Enquiry` : 'Enquiry'} fields={ENQUIRY_FIELDS} submitLabel="Send enquiry" buildMailto={values => `mailto:dop2026live@gmail.com?subject=${encodeURIComponent(`${enquiryType || 'General'} Enquiry — The Doors of Perception`)}&body=${encodeURIComponent(`Name: ${values.name || ''}\nOrganisation: ${values.organisation || ''}\nEmail: ${values.email || ''}\nMessage: ${values.message || ''}`)}`} data-id="element-62" data-mp="2f3mirukma818" />
    </section>;
}